import { Component, ReactNode, FormEvent, MouseEvent } from 'react'

import { REGISTER_URL } from '../../confs/costants'

import Modal from './Modal'
import PrivacyFlag from '../privacy/PrivacyFlag'

import { isValidEmail, isEmpty, isValidPhone, isValidName } from '../../utils/stringValidation'


interface Props {
    isOpen: boolean                 // indica se la modale è aperta
    createUserCallBack: Function    // funzione per creare l'utente
    switchModalCallBack: Function   // apre la modale di rigestrazione
    closeModalCallBack: Function    // funzione per chiudere la modale
}

type PrivacyConsentType = {
    ivass: boolean,
    generale: boolean,
    newsletter: boolean,
    profilazione: boolean,
    commerciale: boolean,
    cessione: boolean,
    cgu: boolean,
    allegato3e4ter: boolean,

    invalidIvass: boolean,
    invalidCgu: boolean,
    invalidGenerale: boolean
}

const defaultPrivacy : PrivacyConsentType = {
    generale: false,
    newsletter: false,
    profilazione: false,
    commerciale: false,
    cessione: false,
    cgu: false,
    ivass: false,
    allegato3e4ter: false,

    invalidIvass: false,
    invalidGenerale: false,
    invalidCgu: false,
}

type registrationInfoType = {
    name: string
    surname: string
    email: string
    phone: string
    password: string
    confirmPassword: string

    invalidName: boolean
    invalidSurname: boolean
    invalidEmail: boolean
    invalidPhone: boolean
    invalidPassword: boolean
    invalidConfirmPassword: boolean
}

const defaultRegistrationInfo = {
    name: '',
    surname: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    invalidName: false,
    invalidSurname: false,
    invalidEmail: false,
    invalidPhone: false,
    invalidPassword: false,
    invalidConfirmPassword: false
}


type State = PrivacyConsentType & registrationInfoType & {
    isLoading: boolean

    confirmIsOpen: boolean

    registrationError: string | undefined
}

class RegisterModal extends Component<Props,State> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...defaultPrivacy,
            ...defaultRegistrationInfo,
            ...{
                isLoading: false,
                confirmIsOpen: false,
                registrationError: undefined,
            }
        }


        this.validate = this.validate.bind(this)
        this.register = this.register.bind(this)

        this.updateName = this.updateName.bind(this)
        this.updateSurname = this.updateSurname.bind(this)
        this.updateEmail = this.updateEmail.bind(this)
        this.updatePhone = this.updatePhone.bind(this)
        this.updatePassword = this.updatePassword.bind(this)
        this.updateConfirmPassword = this.updateConfirmPassword.bind(this)

        this.updateIvass = this.updateIvass.bind(this)
        this.updateGenerale = this.updateGenerale.bind(this)
        this.updateNewsletter = this.updateNewsletter.bind(this)
        this.updateProfilazione = this.updateProfilazione.bind(this)
        this.updateCommerciale = this.updateCommerciale.bind(this)
        this.updateCessione = this.updateCessione.bind(this)
        this.updateCgu = this.updateCgu.bind(this)
        this.updateAllegato3e4ter = this.updateAllegato3e4ter.bind(this)

        this.exit = this.exit.bind(this)
        this.switchModal = this.switchModal.bind(this)

        this.closeConfirm = this.closeConfirm.bind(this)
    }

    componentWillUnmount(): void {
        this.setState({
            ...defaultPrivacy,
            ...defaultRegistrationInfo,
            ...{
                isLoading: false,
                registrationError: undefined,
            }
        })
    }

    render(): ReactNode {
        
        return (
            <>
                <Modal
                    id="register"
                    titleText="Crea il tuo account 6sicuro"
                    isOpen={this.props.isOpen}
                    alitgnTop={true}
                    closeModalCallBack={this.exit}
                >
                    <>
                        <p className='instructions'>
                            Ehi, 6 dei nostri? Inserisci i tuoi dati e scopri tutti i vantaggi dell’area personale di 6sicuro.it.
                        </p>

                        { this.state.registrationError !== undefined &&
                            <p className='error'>
                                { this.state.registrationError }
                            </p>
                        }

                        <div className='two-col'>
                            <div className={this.getContainerClassName(this.state.invalidName)}>
                                <label htmlFor='name'>Nome *</label>
                                <input 
                                    id='name'
                                    name='name'
                                    type='text'
                                    value={this.state.name}
                                    onChange={this.updateName}
                                />
                            </div>
                            <div className={this.getContainerClassName(this.state.invalidSurname)}>
                                <label htmlFor='surname'>Cognome *</label>
                                <input 
                                    id='surname'
                                    name='surname'
                                    type='text'
                                    value={this.state.surname}
                                    onChange={this.updateSurname}
                                />
                            </div>                            
                        </div>

                        <div className='two-col'>
                            <div className={this.getContainerClassName(this.state.invalidEmail)}>
                                <label htmlFor='email'>E-mail *</label>
                                <input 
                                    id='email'
                                    name='email'
                                    type='email'
                                    value={this.state.email}
                                    onChange={this.updateEmail}
                                />
                            </div>
                            <div className={this.getContainerClassName(this.state.invalidPhone)}>
                                <label htmlFor='phone'>Telefono *</label>
                                <input 
                                    id='phone'
                                    name='phone'
                                    type='tel'
                                    value={this.state.phone}
                                    onChange={this.updatePhone}
                                />
                            </div>                            
                        </div>

                        <div className='two-col'>
                            <div className={this.getContainerClassName(this.state.invalidPassword)}>
                                <label htmlFor='password'>Password *</label>
                                <input 
                                    id='password'
                                    name='password'
                                    type='password'
                                    value={this.state.password}
                                    onChange={this.updatePassword}
                                />
                            </div>
                            <div className={this.getContainerClassName(this.state.invalidConfirmPassword)}>
                                <label htmlFor='confirmPassword'>Conferma Password *</label>
                                <input 
                                    id='confirmPassword'
                                    name='confirmPassword'
                                    type='password'
                                    value={this.state.confirmPassword}
                                    onChange={this.updateConfirmPassword}
                                />
                            </div>                            
                        </div>

                        <p>
                            <strong>Informativa IVASS</strong>
                        </p>

                        <PrivacyFlag
                            name='ivass'
                            checked={this.state.ivass}
                            isInvalid={this.state.invalidIvass}
                            updateFlagCallBack={this.updateIvass}
                        >
                            <span>
                                Dichiaro di aver letto l'informativa precontrattuale di cui alla normativa vigente ai sensi del d.lgs. 209/2005 (Codice delle Assicurazioni Private) 
                                e leggi e regolamenti collegati e di averne stampato o salvato copia. Clicca sui link per visualizzare i documenti Allegati&nbsp;
                                <a target="_blank" rel="noreferrer" href="https://www.6sicuro.it/wp-content/uploads/2023/11/SPA-Allegato-3_rev-2023-howden.pdf">3</a>,&nbsp;
                                <a target="_blank" rel="noreferrer" href="https://www.6sicuro.it/wp-content/uploads/2023/11/SPA-Allegato-4_rev-2023-Howden.pdf">4</a>&nbsp;
                                e&nbsp;
                                <a target="_blank" rel="noreferrer" href="https://www.6sicuro.it/wp-content/uploads/2023/11/SPA-Allegato-4TER_rev-2023-howden.pdf">4 TER</a>. (obbligatorio)
                            </span>
                            
                            <ul className="reference-ul">
                                <li className="reference-li">
                                    In ottemperanza all'art. 56 comma 2 e 3 del Reg. IVASS 40/2018, dichiaro di avere salvato o stampato, letto, compreso ed archiviato su supporto duraturo gli&nbsp;
                                    Allegati 3, e 4 TER. In ottemperanza all'art. 9 comma 4 del Reg. IVASS 23/2008, dichiaro altresì di avere stampato, letto, compreso ed archiviato su supporto&nbsp;
                                    duraturo la tabella contenente le informazioni sui livelli provvigionali percepiti dalle compagnie assicurative con cui 6sicuro brand di Howden ha rapporti di&nbsp;
                                    affari nel ramo RCA.
                                </li>
                                <li className="reference-li">
                                    In ottemperanza all'art. 34 del D.L. 1/2012 e dell'art. 6 del Documento di Consultazione 49/2012, dichiaro di aver preso visione delle note informative relative&nbsp;
                                    ai prodotti assicurativi, già predisposte e pubblicate sui siti internet aziendali delle compagnie assicurative di cui il preventivatore di 6sicuro (brand di Howden)&nbsp;
                                    fornisce le quotazioni e raggiungibili dalla pagina note informative.
                                </li>
                                <li className="reference-li">
                                    In ottemperanza all'art.61 del Reg. IVASS 40/2018, dichiaro di voler ricevere tramite l’email comunicata in fase di accesso la documentazione precontrattuale,&nbsp;
                                    i preventivi e la documentazione contrattuale, nonché ogni altra comunicazione proveniente da Howden, con riferimento ai contratti in corso e a quelli futuri.&nbsp;
                                    Sono consapevole della possibilità di modificare la mia scelta in qualsiasi momento, Condizioni generali del servizio.
                                </li>
                            </ul>
                        </PrivacyFlag>

                        <PrivacyFlag
                            name='cgu'
                            checked={this.state.cgu}
                            isInvalid={this.state.invalidCgu}
                            updateFlagCallBack={this.updateCgu}
                        >
                            <span>
                                Accetto le condizioni generali del servizio di comparazione offerto da 6sicuro che dichiaro di aver letto e compreso al seguente&nbsp;
                                <a target="_blank"  rel="noreferrer" href="https://www.6sicuro.it/condizioni-generali-di-utilizzo/">link</a> (necessario per usufruire dei servizi offerti dal Sito).
                            </span>
                        </PrivacyFlag>

                        <p>
                            <strong>Informativa privacy</strong>
                        </p>

                        <PrivacyFlag
                            name='generale'
                            checked={this.state.generale}
                            isInvalid={this.state.invalidGenerale}
                            updateFlagCallBack={this.updateGenerale}
                        >
                            <span>
                                Dichiaro di aver letto <a href="https://www.6sicuro.it/privacy/" target="blank">l’informativa sulla privacy</a> redatta ai sensi del Regolamento&nbsp;
                                (UE) 2016/679 ("GDPR") e specificatamente gli artt. 2.1.a, 2.1.b, 2.1.c, 2.1.d, 2.1.e, 2.i.f, 2.1.g, 2.1.h, 2.1.i. (obbligatorio)
                            </span>
                        </PrivacyFlag>

                        <PrivacyFlag
                            name='newsletter'
                            checked={this.state.newsletter}
                            isInvalid={false}
                            updateFlagCallBack={this.updateNewsletter}
                        >
                            <span>
                                Acconsento all’invio della newsletter (art. 2.1.e dell’informativa) (facoltativo)
                            </span>
                        </PrivacyFlag>

                        <PrivacyFlag
                            name='commerciale'
                            checked={this.state.commerciale}
                            isInvalid={false}
                            updateFlagCallBack={this.updateCommerciale}
                        >
                            <span>
                                Acconsento al trattamento dei dati per le finalità di comunicazione e commerciali operate direttamente da Howden Assiteca (art. 2.1.g dell’informativa) (facoltativo)
                            </span>
                        </PrivacyFlag>

                        <PrivacyFlag
                            name='profilazione'
                            checked={this.state.profilazione}
                            isInvalid={false}
                            updateFlagCallBack={this.updateProfilazione}
                        >
                            <span>
                                Acconsento al trattamento dei dati per le attività di profilazione (art. 2.1.g dell’informativa) (facoltativo)
                            </span>
                        </PrivacyFlag>

                        <PrivacyFlag
                            name='cessione'
                            checked={this.state.cessione}
                            isInvalid={false}
                            updateFlagCallBack={this.updateCessione}
                        >
                            <span>
                                Acconsento al trattamento dei dati per la le finalità di comunicazione, cessione o concessione in uso di dati a terze parti per finalità proprie di queste ultime, per le seguenti categorie (art. 2.1.i dell’informativa) (facoltativo):
                            </span>

                            <ul className="reference-ul">
                                <li className="reference-li">Bancario, finanziario, assicurativo</li>
                                <li className="reference-li">Automotive</li>
                                <li className="reference-li">Beni di largo consumo</li>
                                <li className="reference-li">Telecomunicazioni, telefonia, informatica</li>
                                <li className="reference-li">Servizi alla persona e tempo libero</li>
                            </ul>
                        </PrivacyFlag>

                        <div className='form-input-contaier'>
                            <button
                                disabled={this.state.isLoading}
                                onClick={this.register}
                            >
                                Registrati {this.state.isLoading ? '...' : ''}
                            </button>
                        </div>

                        <p className='center instructions pt1'>
                            Hai già un account?
                            <br/>
                            <a
                                href='#'
                                rel='noreferrer'
                                onClick={this.switchModal}
                            >
                                Accedi
                            </a>
                        </p>

                    </>
                </Modal>

                <Modal
                    id="succes"
                    titleText="Registrazione completata!"
                    isOpen={this.state.confirmIsOpen}
                    closeModalCallBack={this.closeConfirm}
                >
                    <>
                        <p className='instructions'>
                            Riceverai presto un email con un link di conferma: fai click per attivare il tuo profilo.
                        </p>

                        <div className='form-input-contaier'>
                            <button
                                onClick={this.closeConfirm}
                            >
                                Chiudi
                            </button>
                        </div>
                    </>
                </Modal>
            </>
        )
    }
 
    private getContainerClassName (invalid: boolean) {
        return (invalid)
            ? 'invalid form-input-contaier'
            : 'form-input-contaier'
    }

    private switchModal (e: MouseEvent<HTMLAnchorElement>) {
        e.preventDefault()
        e.stopPropagation()

        this.setState({
            ...defaultPrivacy,
            ...defaultRegistrationInfo,
            ...{
                isLoading: false,
                registrationError: undefined,
            }
        }, () => {
            this.props.switchModalCallBack()
        })
    }

    private exit () {
        this.setState({
            ...defaultPrivacy,
            ...defaultRegistrationInfo,
            ...{
                isLoading: false,
                registrationError: undefined,
            }
        }, () => {
            this.props.closeModalCallBack()
        })
    }


    private validate () {
        let next = undefined

        // invertiti per farli uscire in ordine
        if (this.state.generale === false) {
            next = {
                registrationError: 'Controllare e accettare i termini e le condizioni obbligatori',
                invalidGenerale: true
            }
        }
        if (this.state.cgu === false) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Controllare e accettare i termini e le condizioni obbligatori',
                    invalidCgu: true
                }
            }
        }
        if (this.state.ivass === false) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Controllare e accettare i termini e le condizioni obbligatori',
                    invalidIvass: true
                }
            }
        }

        if (
            isEmpty(this.state.password) || isEmpty(this.state.confirmPassword) ||
            this.state.password !== this.state.confirmPassword
        ) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Controllare che le password siano state inserite e che corrispondano',
                    invalidPassword: true,
                    invalidConfirmPassword: true,
                }
            }
        }

        if (!isValidPhone(this.state.phone)) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Numero di telefono non valido',
                    invalidPhone: true
                }
            }
        }
        if (!isValidEmail(this.state.email)) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Indirizzo e-mail non valido',
                    invalidEmail: true
                }
            }
        }
        if (!isValidName(this.state.surname)) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Cognome non valido',
                    invalidSurname: true
                }
            }
        }
        if (!isValidName(this.state.name)) {
            next = {
                ...( next ?? {} ),
                ...{
                    registrationError: 'Nome non valido',
                    invalidName: true
                }
            }
        }
        
        if (next === undefined) {
            return true
        }
        else {
            this.setState( next as State)

            return false
        }
    }

    private register () {
        if (this.validate()) {
            const requestHeaders: HeadersInit = new Headers()
            requestHeaders.append('Origin', 'https://www.6sicuro.it')
            requestHeaders.append('Referer', 'https://www.6sicuro.it/')
            requestHeaders.append('Content-Type', 'application/json; charset="utf-8"')

            this.setState({
                isLoading: true
            }, () => {
                fetch (
                    REGISTER_URL,
                    {
                        method: "POST",
                        headers: requestHeaders,
                        body: JSON.stringify({
                            name: this.state.name,
                            surname: this.state.surname,
                            password: this.state.password,
                            phone: this.state.phone,
                            email: this.state.email,
                            privacy: [
                                {
                                    type: "ivass",
                                    consent: this.state.ivass,
                                    channels: []
                                },
                                {
                                    type: "allegati3e4ter",
                                    consent: this.state.ivass,
                                    channels: []
                                },
                                {
                                    type: "cgu",
                                    consent: this.state.cgu,
                                    channels: []
                                },
                                {
                                    type: "generale",
                                    consent: this.state.generale,
                                    channels: ["email","phone","whatsapp","sms"]
                                },
                                {
                                    type: "commerciale",
                                    consent: this.state.commerciale,
                                    channels: ["email","phone","whatsapp","sms"]
                                },
                                {
                                    type: "newsletter",
                                    consent: this.state.newsletter,
                                    channels: []
                                },
                                {
                                    type: "profilazione",
                                    consent: this.state.profilazione,
                                    channels: []
                                },
                                {
                                    type: "cessione",
                                    consent: this.state.cessione,
                                    channels: ["email","phone","whatsapp","sms"]
                                }
                            ]
                        })
                    }
                )
                .then ( (response) => {
                    if (!response.ok) {
                        let err = new Error("HTTP status code: " + response.status)
                        throw err
                    }

                    return response.json()
                })
                .then ( () => {
                    this.setState({
                        confirmIsOpen: true
                    }, () => {
                        this.exit()
                    })
                })
                .catch ( (err) => {
                    console.log(err)

                    this.setState ({
                        registrationError: 'Login errato, riprovare.'
                    })

                })
                .finally ( () => {
                    this.setState({
                        isLoading: false
                    })
                })
            })
        }
        else {
            setTimeout( () => {
                document.getElementsByClassName("invalid")[0]?.scrollIntoView({behavior: 'smooth'})
            }, 100)
        }
    }
    
    private updateName (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            name: val,
            registrationError: undefined,
            invalidName: false
        })
    }
    private updateSurname (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            surname: val,
            registrationError: undefined,
            invalidSurname: false
        })
    }
    private updateEmail (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            email: val,
            registrationError: undefined,
            invalidEmail: false
        })
    }
    private updatePhone (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            phone: val,
            registrationError: undefined,
            invalidPhone: false
        })
    }

    private updatePassword (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            password: val,
            registrationError: undefined,
            invalidPassword: false
        })
    }
    private updateConfirmPassword (e: FormEvent<HTMLInputElement>) {
        e.stopPropagation()

        const val = e.currentTarget.value ?? ''

        this.setState({
            confirmPassword: val,
            registrationError: undefined,
            invalidConfirmPassword: false
        })
    }

    private updateIvass (val: boolean) {
        this.setState({
            ivass: val
        })
    }
    private updateGenerale (val: boolean) {
        this.setState({
            generale: val
        })
    }
    private updateNewsletter (val: boolean) {
        this.setState({
            newsletter: val
        })
    }
    private updateProfilazione (val: boolean) {
        this.setState({
            profilazione: val
        })
    }
    private updateCommerciale (val: boolean) {
        this.setState({
            commerciale: val
        })
    }
    private updateCessione (val: boolean) {
        this.setState({
            cessione: val
        })
    }
    private updateCgu (val: boolean) {
        this.setState({
            cgu: val
        })
    }
    private updateAllegato3e4ter (val: boolean) {
        this.setState({
            allegato3e4ter: val
        })
    }

    private closeConfirm () {
        this.setState({
            confirmIsOpen: false
        })
    }
}

export default RegisterModal